/**
 * 微信支付成功后向服务端查单并开通 VIP（回调延迟时的补偿）
 */
export async function syncOrderPayAfterWxSuccess(http, orderNo, maxRetries = 6) {
  if (!orderNo) {
    return false
  }
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
  for (let i = 0; i < maxRetries; i++) {
    try {
      const response = await http.post('/api/orders/sync-pay', { order_no: orderNo })
      if (response.data.code === 200) {
        const data = response.data.data || {}
        const payStatus = parseInt(data.pay_status, 10)
        if (payStatus === 1) {
          return true
        }
        const order = data.order
        if (order && parseInt(order.pay_status, 10) === 1) {
          return true
        }
      }
    } catch (e) {
      // 继续重试
    }
    if (i < maxRetries - 1) {
      await delay(800)
    }
  }
  return false
}
